var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_33992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 1.5H1.99531C1.17031 1.5 0.5 2.17969 0.5 3.01406V20.9859C0.5 21.8203 1.17031 22.5 1.99531 22.5H20C20.825 22.5 21.5 21.8203 21.5 20.9859V3.01406C21.5 2.17969 20.825 1.5 20 1.5ZM6.84687 19.5H3.73438V9.47812H6.85156V19.5H6.84687ZM5.29062 8.10938C4.29219 8.10938 3.48594 7.29844 3.48594 6.30469C3.48594 5.31094 4.29219 4.5 5.29062 4.5C6.28437 4.5 7.09531 5.31094 7.09531 6.30469C7.09531 7.30312 6.28906 8.10938 5.29062 8.10938ZM18.5141 19.5H15.4016V14.625C15.4016 13.4625 15.3781 11.9672 13.7844 11.9672C12.1625 11.9672 11.9141 13.2328 11.9141 14.5406V19.5H8.80156V9.47812H11.7875V10.8469H11.8297C12.2469 10.0594 13.2641 9.22969 14.7781 9.22969C17.9281 9.22969 18.5141 11.3062 18.5141 14.0062V19.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_33992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.3b75d2eaea2d3bb29841cab7ff0cb0a7.svg";
export { ForwardRef as ReactComponent };